// extracted by mini-css-extract-plugin
export default {"step-container":"styles_step-container__EXDBg","step-image":"styles_step-image__-nxOJ","step-description":"styles_step-description__2Pygc","step-link":"styles_step-link__hgCSF"};